






















































import { defineComponent, useRouter } from '@nuxtjs/composition-api';
import { TypeBody, BaseButton } from '@bambeehr/pollen';
import bam from '@/lib/bam';

const itemDefault = {
  isComplete: false,
  bullet: '&check;',
  shouldPulse: false,
  variant: 'primary',
};

const generalFeaturesList = [
  {
    ...itemDefault,
    text: 'Easily choose from 600+ available training courses',
  },
  {
    ...itemDefault,
    text: 'Interactive Training Experience',
  },
  {
    ...itemDefault,
    text: 'Custom Training Programs',
  },
  {
    ...itemDefault,
    text: 'Track Training Progress and Completion',
  },
];

const teamRoute = '/my-team';

export default defineComponent({
  name: 'TrainingUpsell',
  components: {
    TypeBody,
    BaseButton,
  },
  emits: ['browse-training'],
  setup(_, { emit }) {
    const router = useRouter();

    const handleBrowseTraining = (location) => {
      bam.trackEvent(`training_overview`, {
        action: 'training-upsell-browse-clicked',
        location,
      });
      emit('browse-training');
    };

    const handleChatWithExpert = () => {
      bam.trackEvent(`training_overview`, {
        action: 'training-upsell-chat-clicked',
      });
      router.push(teamRoute);
    };

    bam.trackEvent('training_overview', {
      action: 'training-upsell-viewed',
    });

    const trainingPricePerEmployee = 24;

    return {
      trainingPricePerEmployee,
      generalFeaturesList,
      handleBrowseTraining,
      handleChatWithExpert,
    };
  },
});
